import React, { useContext, useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import BrunchMenuTable from "views/admin/brunchMenu/components/BrunchMenuTable";
import { columnsData } from "views/admin/menuItem/variables/columnsData";
import { AppContext } from "contexts/AppContext";

export default function BrunchMenu() {
  const options = [{ value: "1", label: "All Brunch Menu Items" }];
  const [selectedOption, setSelectedOption] = useState("1");

  const { brunchMenuItemData, fetchBrunchMenuItemData } =
    useContext(AppContext);
  useEffect(() => {
    fetchBrunchMenuItemData();
  }, []);

  const optionMappings = {
    1: { tableData: brunchMenuItemData, title: "All Brunch Menu Items" },
  };
  const selectedMapping = optionMappings[selectedOption];
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
        width={"100%"}
      >
        {selectedMapping && brunchMenuItemData && (
          <BrunchMenuTable
            columnsData={columnsData}
            tableData={selectedMapping.tableData}
            title={selectedMapping.title}
            setSelectedOption={setSelectedOption}
            options={options}
          />
        )}
      </SimpleGrid>
    </Box>
  );
}
